const noop = () => {};

export function loadGoogleAnalytics() {
  if (typeof global.analytics === 'undefined') {
    return Promise.resolve(noop);
  }
  return new Promise((resolve) => {
    global.analytics.ready(() => {
      resolve(typeof global.ga === 'undefined' ? noop : global.ga);
    });
  });
}

export async function trackPage(aftId) {
  const ga = await loadGoogleAnalytics();
  ga('create', aftId, 'auto', 'sourceTracker', {
    allowLinker: true,
    cookieFlags: 'secure;samesite=none',
  });
  ga('sourceTracker.send', 'pageview');
}

export async function trackEvent(aftId, event, properties) {
  if (event === 'Scheduled Appointment') {
    event = 'Scheduled LocalMed Appointment';
  }
  const googleProperties = {
    eventCategory: 'LocalMed Appointment',
    eventAction: event,
    eventLabel: null,
  };
  if (
    properties &&
    (event === 'Scheduled LocalMed Appointment' || event === 'Viewed LocalMed Appointment Form')
  ) {
    googleProperties.eventLabel = properties.providerId;
  }
  const ga = await loadGoogleAnalytics();
  ga('sourceTracker.send', 'event', googleProperties);
}
